/* LINIGROW — theme interactions. Loaded once, fully delegated. */
(function () {
  if (window.__linigrowReady) return;
  window.__linigrowReady = true;

  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- 1. Scroll reveal (opt-in only when safe) ---------- */
  function initReveal() {
    if (reduced || !('IntersectionObserver' in window)) return;
    document.documentElement.classList.add('lg-anim');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-in');
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    function observe(root) {
      (root || document).querySelectorAll('[data-lg-reveal]:not(.is-in)').forEach(function (el) {
        var d = el.getAttribute('data-lg-reveal');
        if (d && d !== 'true') el.style.transitionDelay = d + 'ms';
        io.observe(el);
      });
    }
    observe(document);

    /* Safety net: nothing may stay invisible. */
    window.setTimeout(function () {
      document.querySelectorAll('[data-lg-reveal]:not(.is-in)').forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight) el.classList.add('is-in');
      });
    }, 1800);

    document.addEventListener('shopify:section:load', function (e) { observe(e.target); });
  }

  /* ---------- 2. Product gallery ---------- */
  function showSlide(gal, index) {
    var slides = gal.querySelectorAll('.lg-gal__slide');
    var thumbs = gal.querySelectorAll('.lg-thumb');
    if (!slides.length) return;
    if (index < 0) index = 0;
    if (index > slides.length - 1) index = slides.length - 1;
    slides.forEach(function (s, i) { s.classList.toggle('is-active', i === index); });
    thumbs.forEach(function (t, i) { t.setAttribute('aria-current', i === index ? 'true' : 'false'); });
    var counter = gal.querySelector('[data-lg-gal-current]');
    if (counter) counter.textContent = String(index + 1);
    var active = thumbs[index];
    if (active && active.scrollIntoView) {
      active.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: reduced ? 'auto' : 'smooth' });
    }
  }

  /* ---------- 3. Quantity ---------- */
  function stepQty(wrap, delta) {
    var input = wrap.querySelector('input[name="quantity"]');
    if (!input) return;
    var min = parseInt(input.getAttribute('min') || '1', 10);
    var max = parseInt(input.getAttribute('max') || '0', 10);
    var val = parseInt(input.value || '1', 10);
    if (isNaN(val)) val = min;
    val += delta;
    if (val < min) val = min;
    if (max > 0 && val > max) val = max;
    input.value = val;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  /* ---------- 4. Delegated events ---------- */
  document.addEventListener('click', function (ev) {
    if (!ev.target.closest) return;

    var thumb = ev.target.closest('[data-lg-thumb]');
    if (thumb) {
      var gal = thumb.closest('[data-lg-gallery]');
      if (gal) showSlide(gal, parseInt(thumb.getAttribute('data-lg-thumb'), 10));
      return;
    }

    var step = ev.target.closest('[data-lg-qty]');
    if (step) {
      ev.preventDefault();
      var wrap = step.closest('.lg-qty');
      if (wrap) stepQty(wrap, step.getAttribute('data-lg-qty') === 'up' ? 1 : -1);
      return;
    }

    var jump = ev.target.closest('[data-lg-scroll-to]');
    if (jump) {
      var target = document.querySelector(jump.getAttribute('data-lg-scroll-to'));
      if (target) {
        ev.preventDefault();
        target.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
      }
    }
  });

  document.addEventListener('keydown', function (ev) {
    if (ev.key !== 'ArrowLeft' && ev.key !== 'ArrowRight') return;
    if (!ev.target.closest) return;
    var gal = ev.target.closest('[data-lg-gallery]');
    if (!gal) return;
    var slides = gal.querySelectorAll('.lg-gal__slide');
    var current = 0;
    slides.forEach(function (s, i) { if (s.classList.contains('is-active')) current = i; });
    showSlide(gal, ev.key === 'ArrowRight' ? current + 1 : current - 1);
  });

  /* ---------- 5. Add to cart (progressive enhancement) ---------- */
  document.addEventListener('submit', function (ev) {
    var form = ev.target;
    if (!form || !form.querySelector) return;
    var btn = form.querySelector('[data-lg-atc]');
    if (!btn) return;            /* not one of ours */
    if (!window.fetch) return;   /* no fetch: let the native POST happen */
    ev.preventDefault();

    var err = form.querySelector('[data-lg-atc-error]');
    var label = btn.querySelector('[data-lg-atc-label]');
    var original = label ? label.textContent : '';
    if (err) err.textContent = '';
    btn.setAttribute('aria-disabled', 'true');
    if (label) label.textContent = btn.getAttribute('data-lg-adding') || 'Adding…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error((res.data && res.data.description) || 'Could not add to cart.');
        if (label) label.textContent = btn.getAttribute('data-lg-added') || 'Added';
        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        window.location.href = root.replace(/\/$/, '') + '/cart';
      })
      .catch(function (e) {
        btn.removeAttribute('aria-disabled');
        if (label) label.textContent = original;
        if (err) err.textContent = e.message || 'Something went wrong. Please try again.';
      });
  });

  /* ---------- 6. Sticky add to cart ---------- */
  function initSticky() {
    var bar = document.querySelector('[data-lg-sticky]');
    if (!bar) return;
    var anchor = document.querySelector('[data-lg-sticky-anchor]');
    if (!anchor || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        bar.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0);
      });
    }, { threshold: 0 });
    io.observe(anchor);
  }

  function boot() {
    initReveal();
    initSticky();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', initSticky);
})();
